import { useApi } from "@lending/lib/api";

function useVehicleOptionsQuery() {
  const $api = useApi();
  const query = $api.useQuery("get", "/v2/lending/car_data/vehicle_options/");

  return {
    vehicleOptions: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { useVehicleOptionsQuery };
